module.exports = __webpack_public_path__ + "static/media/marwan.e3e7ec0f.jpg";